import React from 'react';
import { Icon } from './Icon.js';
export const IconDotsVertical = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 12H12.01", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 5H12.01", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 19H12.01", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconDotsVertical.js.map